<template>
    <!--<HelloWorld />-->
    <transition name="home-animated" enter-active-class="animated slideInRight" leave-active-class="animated slideOutLeft" >
    <div class="page purple darken-3">
        <v-layout align-center justify-center fill-height column>
            <h1 class="display-2 font-weight-light white--text mb-5 text-xs-center">{{ this.appObject.nom }}</h1>
            <div class="box_contador mb-5" v-if="this.isRunning">
                    <!--<h2 class="white--text font-weight-light mb-2">Temps actual de la fitxada:</h2>-->
                    <div class="contador animated slideInUp">
                        <h1 class="display-1 font-weight-light animated fadeIn">{{ this.$store.state.time_formated }}</h1>
                    </div>
            </div>
            <div class="text-xs-center">
                <v-btn class="white white--text" outline light large @click="fitxar">
                    <i class="material-icons mr-2">
                        swap_horiz
                    </i> Fitxar
                </v-btn>
            </div>
        </v-layout>

    </div>
    </transition>
</template>

<script>
    import { mapState, mapActions } from "vuex"

    import axios from "axios"

    export default {
        components: {
            //HelloWorld
        },
        computed: {
            ...mapState(['urlAPI', 'appObject', 'time_formated', 'isRunning']),
        },
        methods: {
            ...mapActions(['setStorage']),

            async fitxar(){

                //Fem la petició per refrescar
                const params = new URLSearchParams(); //Per defecte "axios" serialitza l'objecte javascript a JSON, no tenim la API apunt per rebre json li hem d'enviar en "application/x-www-form-urlencoded"
                params.append('token', this.appObject.token);
                let dades = await axios.post(`${this.urlAPI}refrescar`, params)
                console.log('aqui van les dades rebudes!!!!', dades.data)

                //Actualtizem les dades a la store i també al localStorage
                this.setStorage( dades.data )

                //Tornem a fer un setStorage amb les dades que rebem
                this.$router.push('/fitxar')
            },

        }
        /*mounted() {
            console.log('aqui tenim les dades guardes a "data"', this.$store.state.appObject )
        }*/
    }
</script>

<style>
    .box_contador{display:flex;flex-direction:column;}
    .contador{border:2px solid #fff;width:170px;height:170px;text-align:center;border-radius:100%;padding:20px;display:flex;align-items:center;justify-content:center;display:flex;align-self:center;}
    .contador h1{color:#fff;}
</style>
